export const CALENDAR_COLORS = ["#7e57c2", "#2DCE89", "#ffd740", "#7986cb"];
